const baseApiPaths = {
  'initialize': 'playersubscriptionsearch',
  'search': 'playersubscriptionsearch'
}

const actionsApiPaths = {
  'export': 'PlayerSubscriptions/export',
  'delete': 'api/PlayerSubscriptions',
  'edit': 'live-streams/edit'
}

const apiPathsConfig = {
  ...baseApiPaths,
  ...actionsApiPaths
}

export default apiPathsConfig;